export const Doors = {
  None: 0,
  Two: 1,
  Four: 2,
}

export const NormalizedDoors = {
  [Doors.None]: 'None',
  [Doors.Two]: 'Two',
  [Doors.Four]: 'Four',
}
